module.exports = __webpack_public_path__ + "static/img/logo.f76683e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 0